import { API_ORIGIN, HttpClient } from '@cld/session-service';
import { mapKeys, snakeCase } from 'lodash';

export type UnknownObjectType = Record<string, unknown>;

export type Param = string | Date | undefined | null;

type CollectionParam = string | Array<string | JSON> | null;

type CollectionFormat = 'csv' | 'ssv' | 'tsv' | 'pipes' | 'multi';

const paramsByCollectionFormat = new Map<CollectionFormat, (params: Param[]) => string | Array<string | JSON>>([
  ['csv', (params: Param[]) => params.map(paramToString).join(',')],
  ['ssv', (params: Param[]) => params.map(paramToString).join(' ')],
  ['tsv', (params: Param[]) => params.map(paramToString).join('\t')],
  ['pipes', (params: Param[]) => params.map(paramToString).join('|')],
  ['multi', (params: Param[]) => params.map(paramToString)],
]);
export const buildCollectionParam = (params: Param[] | null, collectionFormat: CollectionFormat): CollectionParam => {
  if (params === null) {
    return null;
  }
  const format = paramsByCollectionFormat.get(collectionFormat);
  return format ? format(params) : null;
};

const paramToString = (param: string | Date | undefined | null): string | JSON => {
  if (param === undefined || param === null) {
    return '';
  }
  if (param instanceof Date) {
    return param.toJSON();
  }
  return param.toString();
};

export const objKeysToSnakeCase = (opts: UnknownObjectType): UnknownObjectType => mapKeys(opts, (value, key) => snakeCase(key));
interface DoFetch {
  stringUrl: URL;
  queryParams?: UnknownObjectType;
  config?: UnknownObjectType;
  httpClient: HttpClient;
}

export const doFetch = ({ stringUrl, queryParams = {}, config = {}, httpClient }: DoFetch): Promise<unknown> => {
  const url = new URL(stringUrl);
  url.search = new URLSearchParams(queryParams as Record<string, string>).toString();
  return httpClient(url.toString(), {
    ...config,
    headers: new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
  });
};

export const fetchDeliveredAndOriginalsClient = (httpClient: HttpClient) => {
  return (counter: string, resourceType: Param[], opts = {}) => {
    const queryParams = {
      'resource_type[]': buildCollectionParam(resourceType, 'multi'),
      force_mo: true,
      ...objKeysToSnakeCase(opts),
    };
    const stringUrl = `${API_ORIGIN}/console/api/v1/reports/derived_and_originals/${counter}` as unknown as URL;
    return doFetch({
      stringUrl,
      queryParams,
      httpClient,
    });
  };
};
